import React, { Component } from 'react';
import Header from '../Components/Header.js';
import Footer from '../Components/Footer.js';
import { Box } from 'grommet/components/Box';
import { Paragraph } from 'grommet/components/Paragraph';
import { Text } from 'grommet/components/Text';
import { Heading } from 'grommet/components/Heading';
import { TextInput } from 'grommet/components/TextInput';
import { isLandingAlertVisible, dismissLandingAlert } from '../Utils/Utility';

const LOGIN_MOCK_LANDING_ALERT_STORAGE_KEY = 'dismissedLoginMockLandingAlert';

// Route di sola preview: non esegue autenticazione, controller o redirect.
class LoginMock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: '',
            password: '',
            showLandingAlert: isLandingAlertVisible(LOGIN_MOCK_LANDING_ALERT_STORAGE_KEY)
        };
        this.setLogin = this.setLogin.bind(this);
        this.dismissLandingAlert = this.dismissLandingAlert.bind(this);
        this.preventLogin = this.preventLogin.bind(this);
    }

    setLogin(event) {
        this.setState({ [event.target.id]: event.target.value });
    }

    dismissLandingAlert() {
        this.setState({ showLandingAlert: false });
        dismissLandingAlert(LOGIN_MOCK_LANDING_ALERT_STORAGE_KEY);
    }

    preventLogin(event) {
        event.preventDefault();
    }

    render() {
        return (
            <Box>
                <Box>
                    <Header />
                    {this.state.showLandingAlert ? (
                        <div role="dialog" aria-modal="true" aria-labelledby="cookiesDialogTitle" style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
                            <div style={{ background: '#ffffff', width: '100%', maxWidth: 560, borderRadius: 4, boxShadow: '0 8px 24px rgba(0,0,0,0.2)', overflow: 'hidden', fontFamily: 'Open Sans,Helvetica Neue,Helvetica,Arial,sans-serif' }}>
                                <div id="cookiesDialogTitle" style={{ background: '#006FCF', color: '#fff', fontWeight: 600, padding: '10px 16px', textAlign: 'center' }}>
                                    Cookies di American Express
                                </div>
                                <div style={{ padding: '16px 16px 8px 16px', color: '#1b1b1b', lineHeight: 1.5, fontSize: 16 }}>
                                    American Express utilizza i cookie su questo sito web per garantirne il corretto funzionamento e la massima sicurezza e per fornire agli utenti i servizi richiesti (cookie essenziali). Per ulteriori informazioni sull'utilizzo dei cookie puo' consultare in qualsiasi momento la nostra 
                                    <a href="https://www.americanexpress.com/content/dam/amex/it/merchant/AXPNexiCookiesPolicyfinal.pdf" target="_blank" rel="noopener noreferrer" style={{ color: '#006FCF', textDecoration: 'underline', fontWeight: 600 }}>
                                        &quot;Cookie policy&quot;
                                    </a>
                                    .
                                </div>
                                <div style={{ padding: '0 16px 20px 16px', display: 'flex', justifyContent: 'center' }}>
                                    <button onClick={this.dismissLandingAlert} style={{ background: '#006FCF', color: '#fff', border: 'none', borderRadius: 2, padding: '10px 24px', cursor: 'pointer', fontWeight: 600 }}>
                                        Chiudi
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : ''}
                    <Box className='background' direction='row' justify='center' gap='small'>
                        <Box className='contentprelogin margin-content'>
                            <Paragraph className='logintext'>
                                Scopri il nuovo Servizio Esercizi Online:
                            </Paragraph>
                            <Paragraph className='logintextp' style={{ color: '#ffffff' }}>
                                il tuo business a portata di click,<br />24/7, in totale sicurezza
                            </Paragraph>
                        </Box>
                        <Box className='contentprelogin'>
                            <Box direction='row' className='loginbox'>
                                <Box className='header loginpanel'>
                                    <Box style={{ padding: '20px' }}>
                                        <Heading className='fixFont' level='1' style={{ marginBottom: '10px' }}>Login</Heading>
                                        <form style={{ textAlign: 'left' }} onSubmit={this.preventLogin}>
                                            <Text className='label'>USER ID</Text>
                                            <TextInput id='user' className='inputlogin' value={this.state.user} placeholder='User ID' onChange={this.setLogin} />
                                            <Text className='label'>PASSWORD</Text>
                                            <TextInput id='password' type='password' className='inputlogin' value={this.state.password} placeholder='Password' onChange={this.setLogin} />
                                            <button type='submit' style={{ marginBottom: '10px', cursor: 'pointer', width: '100%' }} color='transparent' className='btnlogin'>ACCEDI</button>
                                        </form>
                                        <a id='linklogin' href='/RegistrationSelect'>Registrati ora</a>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    <Footer />
                </Box>
            </Box>
        );
    }
}

export default LoginMock;
